import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar";
import Leftbar from "../../components/Leftsidebar";
import Loaderspinner from "../../components/Loader";
import BlogForm from "../../components/Blog/BlogForm";
import { Link } from "react-router-dom";

import { buildBlogFormData } from "../../components/Blog/blogUtils";
import { blogDetail, updateBlog, showToast } from "../Utils/utils";

const EditBlog = () => {
    const { id } = useParams();
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false);
    const [blog, setBlog] = useState({});
    const [showSidebar, setShowSidebar] = useState(false);

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    const fetchDetails = async () => {
        try {
            setLoading(true);

            const res = await blogDetail(id);

            if (res?.status == 200) {
                setBlog(res.data);
            } else {
                showToast("Blog post not found");
                navigate("/blogs");
            }

        } catch (error) {
            console.error(error);
            showToast("Failed to load blog post");
            navigate("/blogs");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDetails();
    }, [id]);

    const onSubmit = async (data) => {
        try {
            setLoading(true);
            const formData = buildBlogFormData(data, id);

            const response = await updateBlog({ formData });
            if (response.status == 200) {
                showToast(response.message || "Blog post updated", "success");
                setTimeout(() => {
                    navigate("/blogs");
                }, 800);
            } else {
                showToast(response?.data?.message || response?.data, "error")
            }

        } catch (error) {
            console.error(error);
            showToast(error.message || "Update failed");

        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loaderspinner />}

            <div className="g-sidenav-show bg-gray-100 min-vh-100">
                <div id="wrapper">

                    <Leftbar
                        showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose}
                    />

                    <main className="main-content border-radius-lg">

                        <Topbar handleSidebar={handleSidebar} />
                        <div>
                            <div className="header header-bg pb-6">
                                <div className="container-fluid">
                                    <div className="header-body">
                                        <div className="row align-items-center py-4">
                                            <div className="col-lg-6 col-7">
                                                <nav
                                                    aria-label="breadcrumb"
                                                    className="d-none d-md-inline-block ml-md-4"
                                                >
                                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/dashboard">
                                                                <i className="fas fa-home" />
                                                            </Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/blogs"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Blog</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to=""><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Edit Blog Post</span></Link>
                                                        </li>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid mt-4">

                                <BlogForm
                                    initialData={blog}
                                    onSubmit={onSubmit}
                                    loading={loading}
                                    buttonName="Update"
                                />

                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default EditBlog;